import { loadContent } from './utils/ajax';
import { elementHasTag, getDataFieldById, updatePageMeta } from './utils/general';
import tplSalesList from './templates/sales_list.pug';

window.addEventListener('DOMContentLoaded', () => {
  
  const interactiveMapEl = document.querySelector('.interactive-map');

  if (interactiveMapEl) {

    // interactive map region changes
    CMS.DataStore.subscribe('interactive_map/region', ({ uri, triggerEl, pushState }) => {
      let isSelect = false;

      if (typeof pushState === 'undefined') {
        pushState = true;
      }
      if (triggerEl) {
        isSelect = elementHasTag(triggerEl, 'select');
        if (isSelect) {
          triggerEl.setAttribute('disabled', '');
        }
        triggerEl.classList.add('disabled');
      }
      loadContent(uri, { pushState })
        .then(response => {
          if (triggerEl) {
            if (isSelect) {
              triggerEl.removeAttribute('disabled');
            }
            triggerEl.classList.remove('disabled');
          }
          renderContent(response.data, {
            currentUrl: uri,
            triggerEl,
          });
        })
        .catch(err => {
          console.error(err);
          if (triggerEl) {
            if (isSelect) {
              triggerEl.removeAttribute('disabled');
            }
            triggerEl.classList.remove('disabled');
          }
        });
    });

    window.addEventListener('popstate', () => {
      const uri = `${window.location.pathname}${window.location.search}`;
      CMS.DataStore.dispatch('interactive_map/region', {
        uri,
        triggerEl: null,
        pushState: false,
      });
    });

    // region path click
    Array.from(document.querySelectorAll('.interactive-map-region')).forEach(regionEl => {
      regionEl.addEventListener('click', e => {
        e.preventDefault();
        
        if (regionEl.classList.contains('disabled') || regionEl.classList.contains('active')) {
          return;
        }

        const uri = regionEl.getAttribute('data-interactive-map-url');
        CMS.DataStore.dispatch('interactive_map/region', {
          uri,
          triggerEl: regionEl,
        });

      }, false);
    });

    // mobile - select change:
    Array.from(document.querySelectorAll('select[name="select_region"]')).forEach(selectEl => {
      selectEl.addEventListener('change', () => {
        const uri = selectEl.value;
        if (uri !== '') {
          CMS.DataStore.dispatch('interactive_map/region', {
            uri,
            triggerEl: selectEl,
          });
        }
      }, false);
    });

  }

});

/**
 * Render content
 * 
 * @param {object} data - Data from backend
 * @param {object} options - Optional settings
 * 
 * @returns {void}
 */
const renderContent = (data, options = {}) => {
  const _defaults = {
    currentUrl: null,
    triggerEl: null,
  };
  const opts = { ..._defaults, ...options };

  // page meta
  updatePageMeta({
    meta_title: (data.tpl.meta_title) ? data.tpl.meta_title : null,
    meta_description: (data.tpl.meta_description) ? data.tpl.meta_description : null,
    og_title: (data.tpl.og_title) ? data.tpl.og_title : null,
    og_description: (data.tpl.og_description) ? data.tpl.og_description : null,
    og_image: (data.tpl.og_image) ? data.tpl.og_image : null,
    og_url: (opts.currentUrl) ? opts.currentUrl : null,
  });
  if (data.tpl.meta_title) {
    document.title = data.tpl.meta_title;
  }

  // breadcrumbs
  const breadcrumbsWrapEl = document.querySelector('[data-slot-breadcrumbs]');
  if (breadcrumbsWrapEl && data.tpl.breadcrumbs_html) {
    breadcrumbsWrapEl.innerHTML = data.tpl.breadcrumbs_html;
  }

  // share row
  const shareRowWrapEl = document.querySelector('[data-slot-share-row]');
  if (shareRowWrapEl) {
    shareRowWrapEl.innerHTML = data.tpl.share_row_html;
  }

  // activate region
  activateRegion(data.id);

  // update list
  const salesListEl = document.querySelector('[data-slot-sales-list]');
  if (salesListEl) {
    let listTitle = `${(data.id) ? getDataFieldById(data.id, 'name', data.regions) : Settings.titles.i18n.sales_list_all} <span class="text-dark">(${data.sales.length})</span>`;
    const salesListHtml = tplSalesList({
      id: (typeof data.id !== 'undefined' && data.id) ? data.id : '',
      listTitle,
      sales: data.sales,
      i18n: Settings.sales.i18n,
    });
    salesListEl.innerHTML = salesListHtml;
  }

};

/**
 * Activate interactive map region
 * 
 * @param {string} regionId - Interactive map region ID
 * @param {object} options - Optional settings
 * @param {string} [options.regionSelector=.interactive-map-region] - Map region CSS selector
 * @param {string} [options.regionActiveClassname=active] - Map region active state CSS classname
 * @param {HTMLSelectElement|string} [options.regionSelectEl=select[name="select_region"]] - Map region select HTML element or CSS selector (on mobile)
 * 
 * @returns {void}
 */
const activateRegion = (regionId, options = {}) => {
  const _defaults = {
    regionSelector: '.interactive-map-region',
    regionActiveClassname: 'active',
    regionSelectEl: 'select[name="select_region"]',
  };
  const opts = { ..._defaults, ...options };
  const regionSelectEl = (typeof opts.regionSelectEl === 'string') ? document.querySelector(opts.regionSelectEl) : opts.regionSelectEl;

  // remove all active classes from map region
  Array.from(document.querySelectorAll(opts.regionSelector)).forEach(regionEl => regionEl.classList.remove(opts.regionActiveClassname));
  
  // add active class to target map region
  const targetRegion = document.querySelector(`${opts.regionSelector}[data-region-id="${regionId}"]`);
  if (targetRegion) {
    targetRegion.classList.add(opts.regionActiveClassname);
  }

  // update mobile select
  if (regionSelectEl) {
    regionSelectEl.value = '';
    const optionEl = Array.from(regionSelectEl.querySelectorAll('option')).find(optionEl => optionEl.getAttribute('data-region-id') === regionId);
    if (optionEl) {
      regionSelectEl.value = optionEl.value;
    }
  }

};
